(function () {
    window.addEventListener('load', function (e) {
        try {
            const sc = document.cookie.replace(/(?:(?:^|.*;\s*)iao\.wordpressCookiesOK\s*\=\s*([^;]*).*$)|^.*$/, '$1');
            if (sc && typeof iaDisableGoogleAnalytics !== 'undefined' && sc.toLowerCase() === 'no') {
                iaDisableGoogleAnalytics();
            } else if (sc && sc.toLowerCase() === 'yes') {
                if (typeof iaEnableGoogleAnalytics !== 'undefined') {
                    iaEnableGoogleAnalytics();
                }
                const cookieEvent = new CustomEvent('cookieConsentGranted', { detail: { consent: true } });
                document.dispatchEvent(cookieEvent);
            } else if (!sc || (sc.toLowerCase() !== 'yes' && sc.toLowerCase() !== 'no')) {
                const cb = document.getElementById('esriukDataObsCookieBanner');
                setTimeout(function () {
                    cb.setAttribute('class', cb.getAttribute('class') + ' in');
                }, 1000);
                const cbbFnc = function (eb) {
                    const v = eb.currentTarget.value;
                    const disallow = v === 'no' || v === 'false' || v === 'out';
                    document.cookie =
                        'iao.wordpressCookiesOK=' +
                        (disallow ? 'no' : 'yes') +
                        ';path=/;expires=Fri, 31 Dec 9999 23:59:59 GMT';
                    cb.setAttribute('class', cb.getAttribute('class').replace(/\sin/g, ''));
                    if (typeof iaEnableGoogleAnalytics !== 'undefined' && !disallow) {
                        iaEnableGoogleAnalytics();
                    }
                    setTimeout(function () {
                        cb.remove();
                    }, 2000);
                    const cookieEvent = new CustomEvent(disallow ? 'cookieConsentDenied' : 'cookieConsentGranted', {
                        detail: { consent: !disallow }
                    });
                    document.dispatchEvent(cookieEvent);
                };
                document.getElementById('esriukDataObsCookieOkButton').addEventListener('click', cbbFnc);
                document.getElementById('esriukDataObsCookieNoButton').addEventListener('click', cbbFnc);
            }
        } catch (cookieEx) {
            // Silent - nice to have...
            console.log('Cannot set cookie - %s', cookieEx); // DEBUG
        }
    });
})();
